export default {
  header: {
    notes: 'Header in invite dialog',
    message: 'Invite user',
  },
  action: {
    openInvite: {
      notes: 'Open invite user dialog action',
      message: 'Invite user with e-mail',
    },
    sendInvite: {
      notes: 'Send invite action',
      message: 'Send invite',
    },
  },
  notification: {
    success: {
      notes:
        'Notification message when user has been created and invited successfully',
      message:
        'User created for {{firstName}} {{lastName}} ({{email}}). The user will find the invite link to SAM Web in the e-mail.',
    },
    error: {
      notes: 'Notification message when failed to create and invite user',
      message: 'Failed to create and invite user. {{message}}.',
    },
  },
};
